import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Input,
  FormGroup,
  Button,
  Label,
  CardHeader,
  CardFooter,
  CustomInput,
  Modal,
  ModalBody,
} from "reactstrap";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import NotificationAlert from "react-notification-alert";
import {
  BASE_URL_CHAT_WHATSAPP,
  WHATSAPP_EMBED_TEMPLATE,
} from "../../constants";
import axios from "axios";
import apiService from "../../variables/apiService";
import "../../assets/scss/style.scss";
import catlogImg from "../../assets/img/catlog.gif";
import mcustomImg from "../../assets/img/mcustom.png";
import mflowsImg from "../../assets/img/mflows.gif";
import callImg from "../../assets/img/callrequest.gif";
import ucustomImg from "../../assets/img/ucustom.png";
import uflowsImg from "../../assets/img/uflows.gif";
import authImg from "../../assets/img/auth.png";
import wtsapImg from "../../assets/img/wtsapbckgrnd.png";
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo.png";
import attach from "../../assets/img/pdf.png";

import {
  WHATSAPP_HEADER_HANDLE,
  WHATSAPP_CAROUSEL_IMG_ID,
  CHANNEL_CLIENT_CHNLTYPE,
} from "../../constants";
import EmojiPicker from "emoji-picker-react";

let initialcategory = "Custom";

const languages = [
  { label: "English", value: "english" },
];
const headres = [
  { label: "None", value: "none" },
  { label: "Text", value: "text" },
  { label: "Image", value: "image" },
  { label: "Video", value: "video" },
  { label: "Document", value: "document" },
  { label: "Carousel", value: "carousel" },
];
const btns = [
  { label: "Custom", value: "QUICK_REPLY" },
  { label: "Call Phone Number", value: "phone_number" },
  { label: "Copy offer code", value: "COPY_CODE" },
  { label: "Visit website", value: "url" },
];

const expirymns = [
  { label: "1 Minute", value: "1" },
  { label: "2 Minutes", value: "2" },
  { label: "3 Minutes", value: "3" },
  { label: "5 Minutes", value: "5" },
  { label: "10 Minutes", value: "10" },
  { label: "15 Minutes", value: "15" },
];

const initialTemp = {
  tempname: "",
  language: { label: "English", value: "english" },
  variable: "",
  header: { label: "None", value: "none" },
  headerContent: { type: "", value: "" },
  body: "Hello",
  footer: "",
  button: [],
};

let templates = [];
const Managetemplates = () => {
  let iscopyofrcodes = false;
  const fileRef = useRef(null);
  const userObj = localStorage.getItem("user");
  const user = JSON.parse(userObj);
  const notificationAlertRef = React.useRef(null);
  const [option, setoption] = useState("setup");
  const [dummylink, setdummylink] = useState("");
  const [dummylinkc, setdummylinkc] = useState([]);
  const [carouselImgid, setCarouselImgid] = useState([]);
  const [validate, setValidate] = useState({});

  const [showemoji, setShowemoji] = useState(false);

  const [temptype, settemptype] = useState("Marketing");
  const [tempcategory, settempcategory] = useState(initialcategory);
  const [buttonUi, setbuttonUi] = useState([]);
  const [dynamicvalueUI, setdynamicvalueUI] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [iscopyofrcode, setIscopyofrcode] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [handlerId, setHandlerId] = useState("");
  const [handlerIdC, setHandlerIdC] = useState([]);

  const [filenm, setfilename] = useState("");

  const [temp, settemp] = useState(initialTemp);

  const [authoption, setauthoption] = useState("copycode");
  const [zerotapchk, setzerotapchk] = useState(false);
  const [appsetupUI, setappsetupUI] = useState([]);
  const [copycont, setcopycont] = useState({
    security: true,
    expiry: false,
    mins: 0,
  });
  const [validity, setvalidity] = useState({
    period: true,
    mins: { label: "10 Minutes", value: "10" },
  });

  const [error, seterror] = useState({
    name: "",
  });

  const textareaRef = useRef(null);

  useEffect(() => {
    fetchChanelsbyClient();
  }, []);
  const fetchChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "whatsapp",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          if (res?.data) {
            templates = [];

            res?.data?.map((wtsap, i) => {
              wtsap?.template && templates.push(wtsap?.template);
            });
          }
          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };
  const submitform = () => {
    setIsLoading(true);
    // {buttonUi?.map((item, index) => {
    buttonUi?.map((item, index) => {
      console.log(item?.type);
      if (item?.type === "COPY_CODE") {
        setIscopyofrcode(true);
        iscopyofrcodes = true;
      }
    });

    const isValidate = (e) => {};
    const formData = new FormData();
    //Save template

    const body = temp?.body;
    let paramsbody = [];

    if (
      temp?.header?.value === "image" ||
      temp?.header?.value === "video" ||
      temp?.header?.value === "document"
    ) {
      const imgTxt = {
        type: "HEADER",
        format: temp?.header?.value?.toUpperCase(),
        example: {
          header_handle: [handlerId],
        },
      };
      paramsbody.push(imgTxt);
      const cparamsbody = JSON.stringify(paramsbody, null, 2);
      paramsbody = JSON.parse(cparamsbody);
    }

    // if (temp?.header?.value === "none" || temp?.header?.value == "text") {
    if (temptype !== "Authentication") {
      if (/{{.*?}}/.test(body)) {
        let params = [];
        dynamicvalueUI?.map((item, index) => {
          params.push(item.text);
        });

        paramsbody.push({
          type: "BODY",

          text: body,
          example: {
            body_text: [params],
          },
        });
      } else {
        paramsbody.push({
          type: "BODY",

          text: body,
        });
      }
    }

    if (temp?.footer?.length > 0) {
      const footerTxt = {
        type: "FOOTER",
        text: temp.footer,
      };
      paramsbody.push(footerTxt);
      const cparamsbody = JSON.stringify(paramsbody, null, 2);
      paramsbody = JSON.parse(cparamsbody);
    }

    if (temp?.header?.value === "carousel") {
      let carousel = {};
      let cardArr = [];
      if (handlerIdC?.length > 1) {
        handlerIdC?.map((item) => {
          cardArr.push({
            components: [
              {
                type: "header",
                format: "image",
                example: {
                  header_handle: [item],
                },
              },
              {
                type: "BUTTONS",
                buttons: buttonUi,
              },
            ],
          });
          carousel = {
            type: "carousel",
            cards: cardArr,
          };
        });
        paramsbody.push(carousel);
      } else {
        const options = {
          place: "tr",
          message: "Please add attachment ",
          type: "warning",
          autoDismiss: 2,
        };
        notificationAlertRef?.current?.notificationAlert(options);
      }
    } else {
      if (buttonUi.length > 0) {
        const btns = {
          type: "BUTTONS",
          buttons: buttonUi,
        };
        paramsbody.push(btns);
        const cparamsbody = JSON.stringify(paramsbody, null, 2);
        paramsbody = JSON.parse(cparamsbody);
      }
    }

    if (temptype === "Authentication") {
      paramsbody.push(
        {
          type: "BODY",
          example: {
            body_text: [["123456"]],
          },
          add_security_recommendation: copycont?.security,
        },
        {
          type: "FOOTER",
          code_expiration_minutes: copycont?.mins,
        },
        {
          type: "BUTTONS",
          buttons: [
            {
              type: "OTP",
              otp_type: "COPY_CODE",
              text: "copy code",
            },
          ],
        }
      );
    }
    // if the template has carousel  need to add cards Start

    // if the template has carousel  need to add cards End
    const componentbody = JSON.stringify(paramsbody);
    formData.append("name", temp.tempname);
    formData.append("language", "en");
    //formData.append("category", temptype.toUpperCase());
    formData.append("category", temptype==="Marketing"?temptype.toUpperCase():temptype==="utility"?"MARKETING":"AUTHENTICATION");

    formData.append("allow_category_change", true);
    // formData.append("components",JSON.stringify([{"type":"BODY","text":"to have you on board. Our team is dedicated to providing you with the best serviceance, prward to a successful journey together!"}]));
    formData.append("components", componentbody);

    // const atoken =
    //   "EAAOIFpeesZB8BOzCaRD4mKk40ySBObFTBH7ZANeHlC9zvzN8ULk9umfZAaZAmpxbJZCFqz7ZAvcb7qrHcrXAxOQZA3Raz5FtXrqqRYoRyzGR1ZB4hGcCDbg1urZBefhvxH1ZBn8sKtYs72prWl1MAXtjdGMmBEuKxZAY54eEhrLxPcjfxIhssBCNYxFhwK3NAy5";

    const config = {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(
        `https://graph.facebook.com/v23.0/${user?.wabaid}/message_templates`,
        formData,
        config
      )
      .then((response) => {
        let options = {};
        options = {
          place: "tr",
          message: "Submitted Successfully and id is " + response?.data.id,
          type: "success",
          autoDismiss: 2,
        };
        notificationAlertRef?.current?.notificationAlert(options);
      //  settemp(initialTemp);
        saveTemplate(response, paramsbody);
      })
      .catch((err) => {
        let options = {};
        options = {
          place: "tr",
          message:
            err?.response?.data?.error?.error_user_msg ||
            err?.response?.data?.error?.message,
          type: "warning",
          autoDismiss: 5,
        };
        notificationAlertRef?.current?.notificationAlert(options);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const saveTemplate = (response, componentbody) => {
    setIsLoading(true);

    const body = temp?.body;
    let paramsbody = [];
    if (
      temp?.header?.value === "image" ||
      temp?.header?.value === "video" ||
      temp?.header?.value === "document"
    ) {
      if (temp?.header?.value === "image") {
        //   const dummylink = "https://whatsappui.netxcell.com/AGP/Ramadan.jpg";
        paramsbody.push({
          type: "header",
          parameters: [
            {
              type: temp?.header?.value,

              [temp?.header?.value]: {
                link: dummylink,
              },
            },
          ],
        });
      }
      if (temp?.header?.value === "video") {
        // const dummylink =
        //   "https://whatsappui.netxcell.com/AGP/AKT%20DPNG%20Bill%20explanation.mp4";
        paramsbody.push({
          type: "header",
          parameters: [
            {
              type: temp?.header?.value,

              [temp?.header?.value]: {
                link: dummylink,
              },
            },
          ],
        });
      }
      if (temp?.header?.value === "document") {
        // const dummylink =
        //   "https://whatsappui.netxcell.com/AGP/AK_Scheme%20Leaflets_A5_Telugu.pdf";
        paramsbody.push({
          type: "header",
          parameters: [
            {
              type: temp?.header?.value,

              [temp?.header?.value]: {
                link: dummylink,
                filename: filenm,
              },
            },
          ],
        });
      }
    }
    if (authoption === "copycode" && temptype === "Authentication") {
      paramsbody.push(
        {
          type: "body",
          parameters: [
            {
              type: "text",
              text: "654321",
            },
          ],
        },
        {
          type: "button",
          sub_type: "url",
          index: "0",
          parameters: [
            {
              type: "text",
              text: "654321",
            },
          ],
        }
      );
    } else if (iscopyofrcodes) {
      paramsbody.push(
        {
          type: "body",
          parameters: [],
        },
        {
          type: "button",
          sub_type: "COPY_CODE",
          index: "0",
          parameters: [
            {
              type: "coupon_code",
              coupon_code: "250OFF",
            },
          ],
        }
      );
    } else {
      if (/{{.*?}}/.test(body)) {
        paramsbody.push({
          type: "body",
          parameters: dynamicvalueUI,
        });
      } else {
        paramsbody.push({
          type: "body",
          parameters: [],
        });
      }
      if (temp?.header?.value === "carousel") {
        // paramsbody.push();
        let carousel = [];
        carouselImgid?.map((imgid, index) => {
          carousel.push({
            card_index: index,
            components: [
              {
                type: "header",
                parameters: [
                  {
                    type: "image",
                    image: {
                      id: imgid,
                    },
                  },
                ],
              },
            ],
          });
        });
        paramsbody.push({
          type: "carousel",
          cards: carousel,
        });
      }
    }
    const payload = {
      name: temp.tempname,
      language: "en",
    //  category: temptype.toUpperCase(),
    category: temptype==="Marketing"?temptype.toUpperCase():temptype==="utility"?"MARKETING":"AUTHENTICATION",

      components: JSON.stringify(paramsbody),

      meta_resp_id: response?.data.id,
      meta_resp_status: response?.data.status,
      clientid: user?.client,
      whatsapp_appid: user?.whatsapp_appid,
      access_token: user?.access_token,
      namespace: user?.namespace,
      senderid: user?.sender_id,
      body:temp?.body
    };

    axios
      .post(WHATSAPP_EMBED_TEMPLATE, payload)
      .then((res) => {
        settemp(initialTemp);
        
        setbuttonUi([]);
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const changeText = (e) => {
    const { name, value } = e.target;

    if (name === "tname") {
      if (value.length < 513) {
        const tname = value
          .toLowerCase()
          .replace(/[^a-z0-9_ ]/g, "")
          .replace(/\s/g, "_");

        settemp({ ...temp, tempname: tname });
        const templateExist = templates?.filter((item) => item == tname);

        if (templateExist.length > 0) {
          setValidate({
            tname: `${tname} already exist`,
          });
        } else {
          console.log("else");
          setValidate({
            tname: "",
          });
        }
      }
    }
  };

  // const addemoji=()=>{

  //   const textarea = textareaRef.current;
  //   const { selectionStart } = textarea;

  //   let newBody = "";

  //   newBody = temp.body.slice(0, selectionStart) + " __";
  //   settemp((prev) => ({ ...prev, body: newBody }));
  // }

  const onEmojiClick = (emojiObject) => {
    const textarea = textareaRef.current;
    const { selectionStart } = textarea;

    let newBody = temp.body.slice(0, selectionStart) + emojiObject.emoji;
    settemp((prev) => ({ ...prev, body: newBody }));
    setShowemoji(false);
  };

  const selctedbody = (name) => {
    const textarea = textareaRef.current;

    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    if (start !== end) {
      // nothing selected

      const selectedText = temp?.body.slice(start, end);
      console.log(selectedText);

      let newBody = "";
      if (temp?.body?.length < 1022) {
        if (name === "bold") {
          newBody =
            temp?.body.slice(0, start) +
            ` *${selectedText}* ` +
            temp?.body.slice(end);
        } else if (name === "italic") {
          newBody =
            temp?.body.slice(0, start) +
            ` _${selectedText}_ ` +
            temp?.body.slice(end);
        } else if (name === "mono") {
          newBody =
            temp?.body.slice(0, start) +
            " ```" +
            selectedText +
            "``` " +
            temp?.body.slice(end);
        }

        settemp((prev) => ({ ...prev, body: newBody }));
      }
    } else {
      const { selectionStart } = textarea;
      let newBody = "";
      if (temp?.body?.length < 1022) {
        if (name === "bold") {
          newBody = temp.body.slice(0, selectionStart) + " ** ";
        } else if (name === "italic") {
          newBody = temp.body.slice(0, selectionStart) + " __ ";
        } else if (name === "mono") {
          newBody = temp.body.slice(0, selectionStart) + " `````` ";
        }

        settemp((prev) => ({ ...prev, body: newBody }));
      }
    }

    // keep cursor selection
    setTimeout(() => {
      textarea.focus();
      textarea.selectionStart = start;
      textarea.selectionEnd = end + 2;
    }, 0);
  };
  const addbody = (name) => {
    const textarea = textareaRef.current;
    const { selectionStart } = textarea;

    let newBody = "";
    if (temp?.body?.length < 1022) {
      if (name === "variable") {
        let matches = temp?.body?.match(/{{.*?}}/g); // non-greedy match
        let count = matches ? matches.length : 0;
        newBody = temp.body.slice(0, selectionStart) + ` {{${++count}}}  `;
      }
      settemp((prev) => ({ ...prev, body: newBody }));
    }
  };

  const uploadImg = (file) => {
    setdummylink("");
    if(temp?.header?.value == "video"&&file?.size>16000000){
      fileRef.current.value = ""
      setIsLoading(false);
      setValidate({
        video: `Uploaded file size must not exceed 16 MB.`,
      }); 
      
    }else if(temp?.header?.value == "image"&&file?.size>5000000){
      fileRef.current.value = ""
      setIsLoading(false);
      setValidate({
        video: `Uploaded file size must not exceed 5 MB.`,
      }); 

    }else if(temp?.header?.value == "document"&&file?.size>100000000){
      fileRef.current.value = ""
      setIsLoading(false);
      setValidate({
        video: `Uploaded file size must not exceed 100 MB.`,
      }); 
    }else{
     
        setValidate({...validate,video:""}); 
        setIsLoading(true)
     
      setfilename(file?.name);
  
      // const config = {
      //   headers: {
      //     // Authorization:
      //     //   "OAuth EAAOIFpeesZB8BOzCaRD4mKk40ySBObFTBH7ZANeHlC9zvzN8ULk9umfZAaZAmpxbJZCFqz7ZAvcb7qrHcrXAxOQZA3Raz5FtXrqqRYoRyzGR1ZB4hGcCDbg1urZBefhvxH1ZBn8sKtYs72prWl1MAXtjdGMmBEuKxZAY54eEhrLxPcjfxIhssBCNYxFhwK3NAy5",
      //     Authorization:`"OAuth ${user?.access_token}"`,
      //       "content-type": "multipart/form-data",
      //   },
      // };
      axios
        //  .post("https://graph.facebook.com/v23.0/9779025878868678/uploads", {
        .post(
          `https://graph.facebook.com/v23.0/${user?.whatsapp_appid}/uploads`,
          {
            file_name: file?.name,
            file_length: file?.size,
            file_type: file?.type,
            access_token: user?.access_token,
          }
        )
        .then((res) => {
          if (temp?.header?.value == "carousel") {
            //  setCarouselImgid
            const formData = new FormData();
            formData.append("file", file);
            formData.append("phone_number_id", user?.phoneid);
            formData.append("access_token", user?.access_token);
  
            axios
              .post(WHATSAPP_CAROUSEL_IMG_ID, formData)
              .then((res) => {
                setCarouselImgid([...carouselImgid, res?.data?.message?.id]);
              })
              .catch((err) => console.log(err, "err"));
          }
          const formData = new FormData();
          formData.append("file", file);
          formData.append("sessionid", res?.data?.id);
          formData.append("access_token", user?.access_token);
          axios
            .post(WHATSAPP_HEADER_HANDLE, formData)
            .then((res) => {
              setHandlerId(res.data.message.h);
              setHandlerIdC([...handlerIdC, res?.data?.message?.h]);
              uploadImglocal(file);
            })
            .catch((err) => {console.log(err, "err");setIsLoading(false);});
            
        })
        .catch((e) =>{ setIsLoading(false); console.log("fail", e)}).finally(()=>{
         
        })
  
      // const formData = new FormData();
      // formData.append("file", file);
      // const config = {
      //   headers: {
      //     "content-type": "multipart/form-data",
      //   },
      // };
      // axios
      //   .post(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      //   .then((response) => {
      //     let imgUrl = response?.data?.Response;
      //     settemp((prev) => ({
      //       ...prev,
      //       headerContent: {
      //         ...prev.headerContent,
      //         type: "image",
      //         value: imgUrl,
      //       },
      //     }));
      //   })
      //   .catch((err) => console.log("err==>", err));
  
    }
    
 

 
  };

  ///

  const uploadImglocal = (file) => {
    setIsLoading(true)
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      .then((response) => {
        console.log("---765",response?.data?.Response);
        // dummylink = response?.data?.Response;
        setdummylink(response?.data?.Response);
        setdummylinkc([...dummylinkc, response?.data?.Response]);

        // settemp((prev) => ({
        //   ...prev,
        //   headerContent: {
        //     ...prev.headerContent,
        //     type: "image",
        //     value: imgUrl,
        //   },
        // }));
      })
      .catch((err) => console.log("err==>", err)).finally(()=>{
        setIsLoading(false)
      })
   
  };

  const createbtn = (val, i, type) => {
    if (type == "remove") {
      const a = buttonUi.filter((item, index) => index != i);

      setbuttonUi(a);
    } else {
      if (val?.value === "url") {
        setbuttonUi((pre) => [...pre, { type: val?.value, text: "", url: "" }]);
      } else if (val?.value === "QUICK_REPLY") {
        setbuttonUi((pre) => [...pre, { type: val?.value, text: "" }]);
      } else if (val?.value === "COPY_CODE") {
        setbuttonUi((pre) => [...pre, { type: val?.value }]);
      } else {
        setbuttonUi((pre) => [
          ...pre,
          { type: val?.value, text: "", [val?.value]: "" },
        ]);
      }
    }
  };

  // Dynamic Variable
  const createdynamicbtn = (i, type) => {
    if (type == "remove") {
      const a = dynamicvalueUI.filter((item, index) => index != i);

      setdynamicvalueUI(a);
    } else {
      setdynamicvalueUI((pre) => [...pre, { type: "text", text: "" }]);
    }
  };

  // App setup
  const createappsetup = (i, type) => {
    if (type == "remove") {
      const a = appsetupUI.filter((item, index) => index != i);

      setappsetupUI(a);
    } else {
      setappsetupUI((pre) => [...pre, { type: "text", text: "" }]);
    }
  };

  const btntxt = (type, index, val) => {
    setbuttonUi((prev) =>
      prev?.map((item, i) => {
        if (i == index && item.type == type) {
          if (type === "COPY_CODE") {
            return { ...item, example: val };
          } else {
            return { ...item, text: val };
          }
        }

        return item;
      })
    );
  };
  const btnvalue = (type, index, val) => {
    setbuttonUi((prev) =>
      prev?.map((item, i) => {
        if (i == index && item.type == type) {
          if (type === "url") {
            return { ...item, url: val };
          } else if (type === "QUICK_REPLY") {
            return { ...item, text: val };
          } else {
            return { ...item, [type]: val };
          }
        }
        return item;
      })
    );
  };

  const dynamicbtnvalue = (index, val) => {
    setdynamicvalueUI((prev) =>
      prev?.map((item, i) => {
        if (i == index) {
          return { ...item, type: "text", text: val };
        }
        return item;
      })
    );
  };

  const appsetupvalue = (type, index, val) => {
    setbuttonUi((prev) =>
      prev?.map((item, i) => {
        if (i == index && item.type == type) {
          return { ...item, [type]: val };
        }
        return item;
      })
    );
  };

  const renderBoldText = (text = "") => {
    return text
      .split(/(\s(?:\*[^*]+\*|_[^_]+_|```[^`]+```)\s)/g)
      .map((part, index) => {
        // BOLD: *text*
        if (/\s\*[^*]+\*\s/.test(part)) {
          const content = part.slice(2, -2); // keep spaces
          return (
            <span key={index}>
              {" "}
              <b>{content}</b>{" "}
            </span>
          );
        }

        // ITALIC: _text_
        if (/\s_[^_]+_\s/.test(part)) {
          const content = part.slice(2, -2);
          return (
            <span key={index}>
              {" "}
              <i>{content}</i>{" "}
            </span>
          );
        }

        // MONO: ```text```
        if (/\s```[^`]+```\s/.test(part)) {
          const content = part.slice(4, -4);
          return (
            <span key={index}>
              {" "}
              <code style={{ fontFamily: "monospace" }}>{content}</code>{" "}
            </span>
          );
        }

        return part;
      });
  };

  return (
    <div className="content">
      <Card style={{ backgroundColor: "#e3e1e1" }}>
        <CardBody>
          <NotificationAlert ref={notificationAlertRef} />
          <LoadingScreen
            children=""
            loading={isLoading}
            bgColor="rgba(0,0,0,0.7)"
            spinnerColor="#9ee5f8"
            textColor="#676767"
            logoSrc={logo}
            text="Loading..."
          ></LoadingScreen>
          <b>Manage Templates</b>
          <Row>
            <Col md="7" sm="12">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 15,
                }}
              >
                <FormGroup
                  style={{
                    backgroundColor: option === "setup" && "#03a9f421",

                    borderRadius: 5,
                  }}
                  check
                  className="form-check-radio template-radio"
                  inline
                >
                  <Label style={{ paddingRight: "20px" }}>
                    <Input
                      id="exampleRadios3"
                      name="exampleRadio"
                      type="radio"
                      value={option}
                      checked={option === "setup" ? true : false}
                      onClick={(e) => setoption("setup")}
                    />
                    <span className="form-check-sign temp" />
                    Set up template
                  </Label>
                </FormGroup>
                <FormGroup
                  check
                  className="form-check-radio template-radio"
                  inline
                  style={{
                    backgroundColor: option === "edit" && "#03a9f421",

                    borderRadius: 5,
                  }}
                >
                  <Label style={{ paddingRight: "20px" }}>
                    <Input
                      id="exampleRadios3"
                      name="exampleRadio"
                      type="radio"
                      value={option}
                      checked={option === "edit" ? true : false}
                      onClick={(e) => {
                        setoption("edit");
                      }}
                    />
                    <span className="form-check-sign temp " />
                    Edit template
                  </Label>
                </FormGroup>
              </div>

              {/* Setup Template */}
              {option === "setup" && (
                <>
                  <div style={{ margin: "10px" }}>
                    <h6>Set up your template</h6>

                    <p>
                      Choose the category that best describes your message
                      template. Then, select the type of message that you want
                      to send. Learn more about categories.
                    </p>
                  </div>
                  <div>
                    <Row
                      style={{
                        border: "1px solid grey",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        textAlign: "center",
                        marginLeft: "10px",
                        height: "37px",
                      }}
                    >
                      <Col
                        md="4"
                        sm="12"
                        style={{
                          background:
                            temptype === "Marketing" ? "#c0c7cb" : "white",
                          padding: 5,
                        }}
                        onClick={() => {
                          settemptype("Marketing");
                          settempcategory(initialcategory);
                        }}
                      >
                        Marketing
                      </Col>
                      <Col
                        md="4"
                        sm="12"
                        style={{
                          background:
                            temptype === "utility" ? "#c0c7cb" : "white",
                          padding: 5,
                          borderLeft: "1px solid grey",
                        }}
                        onClick={() => {
                          settemptype("utility");
                          settempcategory(initialcategory);
                        }}
                      >
                        Utility
                      </Col>
                      <Col
                        md="4"
                        sm="12"
                        style={{
                          background:
                            temptype === "Authentication" ? "#c0c7cb" : "white",
                          padding: 5,
                          borderLeft: "1px solid grey",
                        }}
                        onClick={() => {
                          settemptype("Authentication");
                          settempcategory("otp");
                        }}
                      >
                        Authentication
                      </Col>
                    </Row>
                    {/* Template Category */}
                    <Row>
                      {(temptype === "Marketing" || temptype === "utility") && (
                        <div
                          style={{
                            background:
                              tempcategory === "Custom" ? "#c0c7cb" : "white",
                            marginTop: 10,
                            borderRadius: 5,
                            marginLeft: 10,
                          }}
                          onClick={(e) => settempcategory("Custom")}
                        >
                          <FormGroup
                            check
                            className="form-check-radio template-radio"
                            inline
                          >
                            <Label>
                              <Input
                                id="mrktrdio1"
                                name="mrktrdio"
                                type="radio"
                                value={tempcategory}
                                checked={
                                  tempcategory == "Custom" ? true : false
                                }
                                onClick={(e) => settempcategory("Custom")}
                              />
                              <span className="form-check-sign temp" />
                              Custom
                            </Label>
                          </FormGroup>
                          <p className="template-radio-p">
                            Send promotions or announcements to increase
                            awareness and engagement.
                          </p>
                        </div>
                      )}

                      {temptype === "Authentication" && (
                        <div
                          style={{
                            background:
                              tempcategory === "otp" ? "#c0c7cb" : "white",
                            marginTop: 10,
                            borderRadius: 5,
                            marginLeft: 10,
                          }}
                        >
                          <FormGroup
                            check
                            className="form-check-radio template-radio"
                            inline
                          >
                            <Label>
                              <Input
                                id="mrktrdio4"
                                name="mrktrdio1"
                                type="radio"
                                value="div1"
                                checked={true}
                              />
                              <span className="form-check-sign temp" />
                              One-time passcode
                            </Label>
                          </FormGroup>
                          <p className="template-radio-p">
                            Send codes to verify a transaction or login.
                          </p>
                        </div>
                      )}
                    </Row>
                  </div>
                </>
              )}
              {/* Setup Template */}

              {/* Edit Template Start */}
              {option === "edit" && (
                <div>
                  <Row>
                    <Col>
                      <Card style={{ backgroundColor: "white" }}>
                        <CardBody>
                          <p>
                            <b>
                              {!temp?.tempname
                                ? "your_template_name"
                                : temp?.tempname}
                              .{temp?.language?.label}
                            </b>
                          </p>
                          <span>
                            {temptype} . {tempcategory}
                          </span>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Card style={{ backgroundColor: "white" }}>
                        <CardBody>
                          <b>Template name and language</b>
                          <Row>
                            <Col md="8">
                              <p>Name your template</p>
                              <FormGroup>
                                <Input
                                  type="text"
                                  placeholder="Enter a template name"
                                  value={temp?.tempname}
                                  name="tname"
                                  onChange={(e) => {
                                    changeText(e);
                                  }}
                                />
                              </FormGroup>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span style={{ color: "red" }}>
                                  {validate?.tname}
                                </span>
                                <span>{temp?.tempname?.length}/512</span>
                              </div>
                            </Col>
                            <Col md="4">
                              <p>Select language</p>
                              <Select
                                className="react-select info"
                                classNamePrefix="react-select"
                                name="templateSelect"
                                value={temp.language}
                                onChange={(value) =>
                                  settemp({ ...temp, language: value })
                                }
                                options={languages}
                                placeholder="Select"
                              />
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  {(temptype === "Marketing" || temptype === "utility") && (
                    <>
                      {/* Conent body for Marketing Start */}
                      <Row>
                        <Col>
                          <Card style={{ backgroundColor: "white" }}>
                            <CardBody>
                              <p>
                                <b>Content</b>
                              </p>
                              <p>
                                Fill in the header, body and footer sections of
                                your template.
                              </p>

                              <Row>
                                <Col md="12">
                                  <p>
                                    <b>Header</b>{" "}
                                  </p>
                                  <Select
                                    className="react-select info"
                                    classNamePrefix="react-select"
                                    name="templateSelect"
                                    value={temp?.header}
                                    onChange={(value) => {
                                      setdummylink("");
                                      setdummylinkc([]);
                                      if (fileRef?.current) {
                                        fileRef.current.value = "";
                                      }
                                      settemp({ ...temp, header: value });
                                    }}
                                    options={headres}
                                    placeholder="Select"
                                  />
                                </Col>
                              </Row>

                              {temp?.header?.value != "text" &&
                                temp?.header?.value != "none" && (
                                  <Row>
                                    <Col
                                      md="12"
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        id="file"
                                        ref={fileRef}
                                        accept={temp?.header?.value == "image"?"image/png,image/jpeg":temp?.header?.value == "video"?"video/mp4":"application/pdf"}
                                        onChange={(e) => {
                                          // setImg(e.target.files[0]);
                                          uploadImg(e.target.files[0]);
                                        }}
                                        style={{
                                          border: "1px sold grey",
                                          marginTop: "4px",
                                        }}
                                      />
                                      {dummylink && (
                                        <span
                                          style={{
                                            margin: "6px",
                                            borderRadius: "100%",
                                            background: "red",
                                            color: "white",
                                            width:"20px",
                                            textAlign:"center"
                                          }}
                                          onClick={() => {
                                            setdummylink("");
                                            setdummylinkc([]);
                                            fileRef.current.value = "";
                                          }}
                                        >
                                          <i class="tim-icons icon-simple-remove"></i>
                                        </span>
                                      )}
                                      
                                    </Col>
                                    <span style={{ color: "red" }}>
                                  {validate?.video}
                                </span>
                                  </Row>
                                )}

                              <Row>
                                {showModal && (
                                  <div
                                    style={{
                                      zIndex: 999,
                                      borderRadius: 5,
                                      position: "absolute",
                                      maxWidth: "80%",
                                      background: "#a1cb6a",
                                      color: "white",
                                      marginLeft: 50,
                                      marginTop: 20,
                                    }}
                                  >
                                    <div style={{ padding: 10 }}>
                                      <b>Rules</b>
                                      <ul>
                                        <li>
                                          Template name should be small letters
                                        </li>
                                        <li>
                                          Body should not start/end with
                                          variable
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                )}
                                <Col md="12">
                                  <p>
                                    <b>Body </b>{" "}
                                    <i
                                      onClick={() => setShowModal(!showModal)}
                                      class="fa fa-info-circle"
                                      aria-hidden="true"
                                    ></i>
                                    <span
                                      style={{
                                        color: "gray",
                                        float: "right",
                                        fontSize: 12,
                                        marginTop: 10,
                                        whiteSpace: "pre-line",
                                      }}
                                    >
                                      {temp?.body?.length}/1024
                                    </span>
                                  </p>

                                  <Input
                                    style={{
                                      padding: "5px",
                                      resize: "auto",
                                      maxHeight: "none",
                                      letterSpacing: "1px",
                                      fontSize: 14,
                                    }}
                                    type="textarea"
                                    name="message"
                                    innerRef={textareaRef}
                                    value={temp.body}
                                    onChange={(e) => {
                                      settemp({
                                        ...temp,
                                        body: e.target.value,
                                      });
                                    }}
                                    maxLength={1024}
                                  />
                                  <div style={{ float: "right" }}>
                                    <span
                                      style={{ marginRight: "10px" }}
                                      onClick={() => setShowemoji(!showemoji)}
                                    >
                                      <i className="tim-icons icon-satisfied" />
                                    </span>

                                    <span
                                      style={{ marginRight: "10px" }}
                                      onClick={() => selctedbody("bold")}
                                    >
                                      <i>B</i>
                                    </span>
                                    <span
                                      style={{ marginRight: "10px" }}
                                      onClick={() => selctedbody("italic")}
                                    >
                                      <i>I</i>
                                    </span>
                                    <span
                                      style={{ marginRight: "10px" }}
                                      onClick={() => selctedbody("mono")}
                                    >
                                      {"</>"}
                                    </span>
                                    <span
                                      onClick={(value) => {
                                        addbody("variable");
                                        createdynamicbtn(0, "add");
                                      }}
                                    >
                                      <b>+ Add variable</b>
                                    </span>
                                  </div>
                                </Col>

                                <Row className="mt-4">
                                  {dynamicvalueUI?.map((item, index) => {
                                    return (
                                      <Row>
                                        {index === 0 && <p>Body</p>}
                                        <Col md="5">
                                          <FormGroup>
                                            <Input
                                              type="text"
                                              placeholder="enter text"
                                              value={`{{${index + 1}}}`}
                                              name="btntxt"
                                              disabled={true}
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col md="5">
                                          <FormGroup>
                                            <Input
                                              type="text"
                                              placeholder={`Enter content for {{${
                                                index + 1
                                              }}}`}
                                              value={item[index]?.text}
                                              name="btntxt"
                                              onChange={(e) =>
                                                dynamicbtnvalue(
                                                  index,
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col
                                          md="2"
                                          style={{ cursor: "pointer" }}
                                        >
                                          <span
                                            onClick={() =>
                                              createdynamicbtn(index, "remove")
                                            }
                                          >
                                            Remove
                                          </span>
                                        </Col>
                                      </Row>
                                    );
                                  })}

                                  <Col md="8"></Col>
                                </Row>
                              </Row>
                              <Row></Row>
                              <Row>
                                <Col md="12">
                                  <label>Footer</label>
                                  <FormGroup>
                                    <Input
                                      type="text"
                                      placeholder="Enter text"
                                      value={temp.footer}
                                      name="tname"
                                      onChange={(e) =>
                                        settemp({
                                          ...temp,
                                          footer: e.target.value,
                                        })
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      {/* Conent body for Marketing  End*/}

                      {/* Conent body for Marketing Buttons Start*/}

                      <Row>
                        <Col>
                          <Card style={{ backgroundColor: "white" }}>
                            <CardBody>
                              <p>
                                <b>Buttons• </b> Optional
                              </p>
                              <p>
                                Create buttons that let customers respond to
                                your message or take action. You can add up to
                                ten buttons. If you add more than three buttons,
                                they will appear in a list.
                              </p>
                              <Row>
                                <Col md="6">
                                  <Select
                                    className="react-select info"
                                    classNamePrefix="react-select"
                                    name="templateSelect"
                                    // value={temp?.button}
                                    onChange={(value) =>
                                      createbtn(value, 0, "add")
                                    }
                                    options={btns}
                                    placeholder="Add Button"
                                  />
                                </Col>
                                <Col></Col>
                              </Row>
                              <Row className="mt-4">
                                {buttonUi?.map((item, index) => {
                                  return (
                                    <Row style={{ marginBottom: 20 }}>
                                      <span>{item.type}</span>
                                      <Col md="5">
                                        <FormGroup>
                                          {item.type != "QUICK_REPLY" &&
                                            item.type != "COPY_CODE" && (
                                              <p>Button Text</p>
                                            )}
                                          <Input
                                            type="text"
                                            placeholder={
                                              item.type == "QUICK_REPLY"
                                                ? `Enter quick reply text `
                                                : item.type == "COPY_CODE"
                                                ? `Enter copy offer code`
                                                : `Enter text`
                                            }
                                            value={
                                              buttonUi[index]?.text ||
                                              buttonUi[index]?.example
                                            }
                                            name="btntxt"
                                            onChange={(e) =>
                                              btntxt(
                                                item.type,
                                                index,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </FormGroup>
                                      </Col>

                                      {item.type === "url" &&
                                        item.type != "QUICK_REPLY" && (
                                          <Col md="5">
                                            <FormGroup>
                                              <p>Website URL</p>
                                              <Input
                                                type="text"
                                                placeholder="enter text"
                                                value={buttonUi[index]?.url}
                                                name="btntxt"
                                                onChange={(e) =>
                                                  btnvalue(
                                                    item.type,
                                                    index,
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </FormGroup>
                                          </Col>
                                        )}
                                      {item.type !== "url" &&
                                        item.type != "QUICK_REPLY" &&
                                        item.type != "COPY_CODE" && (
                                          <Col md="5">
                                            <FormGroup>
                                              <p>Phone Number</p>

                                              <Input
                                                type="text"
                                                placeholder="enter text"
                                                value={buttonUi[index]?.payload}
                                                name="btntxt"
                                                onChange={(e) =>
                                                  btnvalue(
                                                    item.type,
                                                    index,
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </FormGroup>
                                          </Col>
                                        )}

                                      <Col md="2" style={{ cursor: "pointer" }}>
                                        <span
                                          onClick={() =>
                                            createbtn("", index, "remove")
                                          }
                                        >
                                          Remove
                                        </span>
                                      </Col>
                                    </Row>
                                  );
                                })}

                                <Col md="8"></Col>
                              </Row>

                              <Row></Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>

                      {/* Conent body for Marketing Buttons  End */}
                    </>
                  )}
                  {temptype === "Authentication" && (
                    <>
                      <Row>
                        <Col>
                          <Card style={{ backgroundColor: "white" }}>
                            <CardBody>
                              <p>
                                <b>Code delivery setup</b>
                              </p>
                              {/* <Row>
                                <FormGroup
                                  check
                                  className="form-check-radio template-radio"
                                  inline
                                >
                                  <Label style={{ paddingRight: "20px" }}>
                                    <Input
                                      id="authRadio"
                                      name="authRadio"
                                      type="radio"
                                      value={authoption}
                                      checked={
                                        authoption === "zerotap" ? true : false
                                      }
                                      onClick={(e) => setauthoption("zerotap")}
                                    />
                                    <span className="form-check-sign temp" />
                                    Zero-tap auto-fill
                                  </Label>
                                </FormGroup>
                                <p>
                                  This is recommended as the easiest option for
                                  your customers. Zero-tap will automatically
                                  send code without requiring your customer to
                                  tap a button. An auto-fill or copy code
                                  message will be sent if zero-tap and auto-fill
                                  aren't possible.
                                </p>
                                {authoption === "zerotap" && (
                                  <div>
                                    <FormGroup
                                      check
                                      style={{
                                        padding: "10px",
                                        background: "#9188885e",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <Label check>
                                        <Input
                                          type="checkbox"
                                          checked={zerotapchk}
                                          value={zerotapchk}
                                          onClick={(e) => {
                                            setzerotapchk(!zerotapchk);
                                          }}
                                        />
                                        <span className="form-check-sign" />
                                        <p>
                                          By selecting zero-tap, I understand
                                          that Netxcell Account's use of
                                          zero-tap authentication is subject to
                                          the WhatsApp Business Terms of Service
                                          . It's Netxcell Account 's
                                          responsibility to ensure that its
                                          customers expect that the code will be
                                          automatically filled in on their
                                          behalf when they choose to receive the
                                          zero-tap code through WhatsApp.
                                        </p>
                                        <p
                                          style={{
                                            padding: "10px",
                                            background: "#f5b7b773",
                                          }}
                                        >
                                          This box must be ticked to submit this
                                          template.
                                        </p>
                                      </Label>
                                    </FormGroup>
                                  </div>
                                )}
                              </Row> */}
                              {/* <Row>
                                <FormGroup
                                  check
                                  className="form-check-radio template-radio"
                                  inline
                                >
                                  <Label style={{ paddingRight: "20px" }}>
                                    <Input
                                      id="authRadio"
                                      name="authRadio"
                                      type="radio"
                                      value={authoption}
                                      checked={
                                        authoption === "onetap" ? true : false
                                      }
                                      onClick={(e) => {
                                        setauthoption("onetap");
                                      }}
                                    />
                                    <span className="form-check-sign temp " />
                                    One-tap auto-fill
                                  </Label>
                                </FormGroup>
                                <p>
                                  The code sends to your app when customers tap
                                  the button. A copy code message will be sent
                                  if auto-fill isn't possible.
                                </p>
                              </Row> */}
                              <Row>
                                <FormGroup
                                  check
                                  className="form-check-radio template-radio"
                                  inline
                                  style={{
                                    borderRadius: 5,
                                  }}
                                >
                                  <Label style={{ paddingRight: "20px" }}>
                                    <Input
                                      id="authRadio"
                                      name="authRadio"
                                      type="radio"
                                      value={authoption}
                                      checked={
                                        authoption === "copycode" ? true : false
                                      }
                                      onClick={(e) => {
                                        setauthoption("copycode");
                                      }}
                                    />
                                    <span className="form-check-sign temp " />
                                    Copy code
                                  </Label>
                                </FormGroup>
                                <p>
                                  Basic authentication with quick setup. Your
                                  customers copy and paste the code into your
                                  app.
                                </p>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      {(authoption === "zerotap" ||
                        authoption === "onetap") && (
                        <Row>
                          <Col>
                            <Card style={{ backgroundColor: "white" }}>
                              <CardBody>
                                <p>
                                  <b> App setup</b>
                                </p>
                                <p>You can add up to 5 apps.</p>

                                <br />

                                <Row>
                                  {appsetupUI?.map((item, index) => {
                                    return (
                                      <Row>
                                        <Col md="7">
                                          <b>Package name</b>
                                          <FormGroup>
                                            <Input
                                              type="text"
                                              placeholder="Enter text"
                                              value={item?.pkgname}
                                              name="pkgname"
                                              onChange={(e) => {
                                                appsetupvalue(
                                                  "pkgname",
                                                  index,
                                                  e.target.value
                                                );
                                              }}
                                            />
                                          </FormGroup>
                                          <span style={{ float: "right" }}>
                                            {item?.pkgname?.length}/512
                                          </span>
                                        </Col>
                                        <Col md="3">
                                          <b>App signature hash</b>
                                          <FormGroup>
                                            <Input
                                              type="text"
                                              placeholder="Enter text"
                                              value={item?.signature}
                                              name="signature"
                                              onChange={(e) => {
                                                appsetupvalue(
                                                  "signature",
                                                  index,
                                                  e.target.value
                                                );
                                              }}
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col md="1">
                                          <span style={{ float: "right" }}>
                                            {item?.signature?.length}/11
                                          </span>
                                        </Col>
                                        <span
                                          onClick={() =>
                                            createappsetup(index, "remove")
                                          }
                                        >
                                          Remove
                                        </span>
                                      </Row>
                                    );
                                  })}
                                  <div
                                    style={{
                                      padding: "10px",
                                      background: "#f5b7b773",
                                      margin: "20px",
                                      width: "95%",
                                    }}
                                  >
                                    <ul>
                                      <li>
                                        Your signature hash must be 11
                                        characters long.
                                      </li>
                                      <li>
                                        Add text in all required fields to
                                        publish your message template.
                                      </li>
                                    </ul>
                                  </div>
                                  <div
                                    style={{
                                      border: "1px solid grey",
                                      padding: "5px",
                                      marginLeft: "20px",
                                      width: "150px",
                                    }}
                                  >
                                    <p
                                      onClick={(value) => {
                                        createappsetup(0, "add");
                                      }}
                                    >
                                      Add another app
                                    </p>
                                  </div>
                                </Row>

                                <div></div>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col>
                          <Card style={{ backgroundColor: "white" }}>
                            <CardBody>
                              <p>
                                <b>Content</b>
                              </p>
                              <p>
                                Content for authentication message templates
                                can't be edited. You can add additional content
                                from the options below.
                              </p>

                              <div>
                                <FormGroup
                                  check
                                  style={{
                                    padding: "10px",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      checked={copycont?.security}
                                      value={copycont?.security}
                                      onClick={(e) => {
                                        setcopycont({
                                          ...copycont,
                                          security: !copycont.security,
                                        });
                                      }}
                                    />
                                    <span className="form-check-sign" />
                                    <p>Add security recommendation</p>
                                  </Label>
                                </FormGroup>
                                <FormGroup
                                  check
                                  style={{
                                    padding: "10px",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      checked={copycont?.expiry}
                                      value={copycont?.expiry}
                                      onClick={(e) => {
                                        setcopycont({
                                          ...copycont,
                                          expiry: !copycont.expiry,
                                        });
                                      }}
                                    />
                                    <span className="form-check-sign" />
                                    <p>Add expiry time for the code</p>
                                    <span>
                                      After the code has expired, the auto-fill
                                      button will be disabled.
                                    </span>
                                  </Label>
                                </FormGroup>
                                {copycont?.expiry && (
                                  <div>
                                    <p>Expires in (minutes)</p>
                                    <FormGroup>
                                      <Input
                                        type="number"
                                        value={copycont?.mins}
                                        min={1}
                                        onChange={(e) => {
                                          setcopycont({
                                            ...copycont,
                                            mins: e.target.value,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </div>
                                )}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <Card style={{ backgroundColor: "white" }}>
                            <CardBody>
                              <p>
                                {" "}
                                <b>Message validity period</b>{" "}
                              </p>
                              <span>
                                It's recommended to set a custom validity period
                                that your authentication message must be
                                delivered by before it expires. If a message is
                                not delivered within this time frame, you will
                                not be charged and your customer will not see
                                the message.
                              </span>
                              <br />
                              <p
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <b>
                                  Set custom validity period for your message
                                </b>{" "}
                                <div className="d-flex align-items-center">
                                  <CustomInput
                                    type="switch"
                                    id="switch-5"
                                    className="mt-n4"
                                    checked={validity.period}
                                    onChange={() =>
                                      setvalidity({
                                        ...validity,
                                        period: !validity.period,
                                      })
                                    }
                                  />
                                </div>
                              </p>
                              <span>
                                If you don't set a custom validity period, the
                                standard 10 minutes WhatsApp message validity
                                period will be applied.
                              </span>

                              <div>
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  name="templateSelect"
                                  value={validity.mins}
                                  onChange={(value) =>
                                    setvalidity({ ...validity, mins: value })
                                  }
                                  options={expirymns}
                                  placeholder="Select"
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </>
                  )}
                </div>
              )}

              {/* Edit Template End */}
              <div></div>
            </Col>

            <Col md="4" sm="12">
              <Card
                style={
                  {
                    // marginBottom: "15px",
                    // marginTop: "15px",
                    // minHeight:"56%",
                    // position:"fixed",
                    // maxWidth:"30%",
                    // zIndex:9999
                  }
                }
              >
                <CardHeader style={{ backgroundColor: "#d5d4d4" }}>
                  <b>Template Preview</b>
                </CardHeader>
                {option === "setup" && (
                  <CardBody style={{ backgroundColor: "#d5d4d4" }}>
                    {tempcategory === "Custom" && temptype === "Marketing" && (
                      <img src={mcustomImg} />
                    )}
                    {tempcategory === "catalogue" && <img src={catlogImg} />}

                    {tempcategory === "Flows" && temptype === "Marketing" && (
                      <img src={mflowsImg} />
                    )}
                    {tempcategory === "Flows" && temptype === "utility" && (
                      <img src={uflowsImg} />
                    )}
                    {tempcategory === "Calling permissions request" && (
                      <img src={callImg} />
                    )}
                    {tempcategory === "Custom" && temptype === "utility" && (
                      <img src={ucustomImg} />
                    )}
                    {temptype === "Authentication" && <img src={authImg} />}
                  </CardBody>
                )}
                {option === "edit" && (
                  <CardBody style={{ backgroundColor: "#d5d4d4" }}>
                    <div
                      style={{
                        width: "auto",
                        backgroundColor: "white",
                        // minHeight: "20%",
                        // minWidth: "20%",
                        borderBottomRightRadius: 5,
                        borderTopRightRadius: 5,
                        borderBottomLeftRadius: 5,
                        height: "auto",
                        // width: "200px",
                      }}
                    >
                      {temp?.header?.value == "image" && (
                        <div>
                          <img
                            src={dummylink}
                            style={{
                              height: "auto",
                              width: "200px",
                              backgroundColor: "white",
                            }}
                          />
                        </div>
                      )}
                       {temp?.header?.value == "document"&&dummylink && (
                        <div>
                          <img
                            src={attach}
                            style={{
                              height: "auto",
                              width: "200px",
                              backgroundColor: "white",
                            }}
                          />
                        </div>
                      )}

                      {(temp?.header?.value == "video"&&dummylink) && (
                        <div>
                          {/* https://whatsappui.netxcell.com:8373/files/4114797-uhd_3840_2160_25fps.mp4 */}

                          <video
                            width="280"
                            controls
                            crossOrigin="anonymous"
                            onPlay={() => console.log("Video started")}
                            onPause={() => console.log("Video paused")}
                          >
                            <source src={dummylink} type="video/mp4" />
                          </video>
                        </div>
                      )}
                      <p
                        style={{
                          color: "black",
                          padding: 10,
                          whiteSpace: "pre-line",
                          maxHeight: "30%",
                          overflowY: "auto",
                        }}
                      >
                        {renderBoldText(temp?.body)}
                      </p>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        {temp?.header?.value == "carousel" &&
                          dummylinkc?.map((item, index) => {
                            return (
                              <div style={{}}>
                                <img
                                  src={item}
                                  style={{
                                    height: "auto",
                                    width: "100px",
                                    backgroundColor: "white",
                                    margin: 5,
                                  }}
                                />
                              </div>
                            );
                          })}
                      </div>
                      {temp.footer.length > 0 && (
                        <div>
                          {" "}
                          <p style={{ color: "grey", padding: 10 }}>
                            {temp.footer}
                          </p>
                        </div>
                      )}

                      <div style={{ textAlign: "center" }}>
                        {buttonUi?.map((item, index) => {
                          return (
                            <p
                              style={{
                                borderTop: "1px solid #e1dddd",
                                padding: 10,
                                color: "blue",
                              }}
                            >
                              {" "}
                              {item.text || "Button Text"}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  </CardBody>
                )}
              </Card>
              {showemoji && (
                <EmojiPicker
                  onEmojiClick={onEmojiClick}
                  searchDisabled={true}
                  skinTonesDisabled={false}
                  previewConfig={{ showPreview: false }}
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "40px",
                    zIndex: "999",
                  }}
                />
              )}
            </Col>
          </Row>
        </CardBody>
        <CardFooter>
          <Card>
            <CardFooter>
              <Row>
                {option === "setup" ? (
                  <Col md="10" sm="12"></Col>
                ) : (
                  <>
                    <Col md="2" sm="12">
                      <Button
                        color="primary "
                        className="mt-4 btn "
                        id="tooltipsubmit"
                        type="button"
                        onClick={() => setoption("setup")}
                      >
                        Previous
                      </Button>
                    </Col>
                    <Col md="8" sm="12"></Col>
                  </>
                )}
                {option === "setup" ? (
                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn "
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => setoption("edit")}
                    >
                      Next
                    </Button>
                  </Col>
                ) : (
                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn "
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => submitform()}
                    >
                      Submit
                    </Button>
                  </Col>
                )}
              </Row>
            </CardFooter>
          </Card>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Managetemplates;
